import { formatRevenueCurrency } from "./revenueCurrency";

export const REVENUE_COLORS = {
  guestServices: "#CAC19F",
  guesteriaPartners: "#826BFF",
  externalServices: "#9B90DA",
  app: "#CAC19F",
  whatsapp: "#A599E8",
} as const;

export const REVENUE_LEGEND_PERCENT_COLOR = "#878065";
export const REVENUE_LEGEND_AMOUNT_COLOR = "#F97316";

export const REVENUE_DONUT_SEGMENT_STROKE = "#FFFFFF";
export const REVENUE_DONUT_SEGMENT_STROKE_WIDTH = 1;
export const REVENUE_DONUT_INNER_RADIUS = 72;
export const REVENUE_DONUT_OUTER_RADIUS = 100;
export const REVENUE_DONUT_EMPTY_RING_COLOR = "#ECEAF7";

export const REVENUE_CHART_CARD_ICON_COLOR = "#9B90DA";
export const REVENUE_CHART_CARD_ICON_SIZE = 16;
export const REVENUE_CHART_CARD_ICON_STROKE_WIDTH = 1.33;
export const REVENUE_CHART_CARD_HEADER_GAP = 12;
export const REVENUE_CHART_CARD_HEADER_HEIGHT = 24;
export const REVENUE_CHART_CARD_PADDING = 16;
export const REVENUE_CHART_LEGEND_GAP = 16;

export const REVENUE_CHART_CARD_WIDTH = 512;
export const REVENUE_DONUT_CHART_SIZE = 240;
export const REVENUE_STACKED_AREA_CHART_HEIGHT = 504;

export const REVENUE_CHART_CARD_SHADOW =
  "shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.1),0px_1px_3px_0px_rgba(0,0,0,0.1)]";

/** @deprecated Use formatRevenueCurrency(value, currency) from ./revenueCurrency */
export function formatEuro(value: number): string {
  return formatRevenueCurrency(value, "EUR");
}
